import { RouteObject } from "react-router-dom";
import { BookingDriverActivity, BookingOffer, NotFound, PayInvoice, JobRating, RouteError, VeivoVerification } from "@/components/pages";
import { GuestBooking, GuestBookingConfirmation } from "@/components/pages/Guest";
import { Public } from "@/containers";

export const publicRoutes: RouteObject = {
  path: "/",
  element: <Public />,
  children: [
    {
      // Guest booking — public, no RequireAuth. Single quote-driven entry: the operator quote widget
      // deep-links with `?widget=v1&quote_uuid=…` (no operator code); GuestBooking resolves the operator
      // FROM the quote and rehydrates the draft from it.
      path: "guest/booking",
      errorElement: <RouteError />,
      children: [
        {
          index: true,
          element: <GuestBooking />,
        },
        {
          // Guest booking success — reached after a successful guest booking-create.
          path: "confirmation",
          element: <GuestBookingConfirmation />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
    {
      path: "booking-offer/:providerId/:accountId/:jobId/:jobKey",
      errorElement: <BookingOffer.NotFound />,
      children: [
        {
          index: true,
          element: <BookingOffer />,
        },
        {
          path: "rejected",
          element: <BookingOffer.Rejected />,
        },
        {
          path: "*",
          element: <BookingOffer.NotFound />,
        },
      ],
    },
    {
      path: "trip-log/:jobId/:hash",
      errorElement: <NotFound />,
      children: [
        {
          index: true,
          element: <BookingDriverActivity />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
    {
      path: "pay-invoice/:providerId/:companyId/:invoiceId/:invoiceKey",
      errorElement: <RouteError />,
      children: [
        {
          index: true,
          element: <PayInvoice />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
    {
      // Phone half of the Veivo QR handoff. Unauthenticated by design: the
      // driver scans this at the car, and the SDK carries its own short-lived
      // session token in the URL fragment.
      path: "veivo-verification",
      errorElement: <RouteError />,
      children: [
        {
          index: true,
          element: <VeivoVerification />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
    {
      path: "job-rating/:jobId/:actionKey",
      errorElement: <RouteError />,
      children: [
        {
          index: true,
          element: <JobRating />,
        },
        {
          path: "success",
          element: <JobRating.Success />,
        },
        {
          path: "expired",
          element: <JobRating.Expired />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
  ],
};
